// removed by extract-text-webpack-plugin
module.exports = {"button":"MostPlayedButton__button__1PEv4","noBottomBorder":"MostPlayedButton__noBottomBorder__2jP1q","legendIcon":"MostPlayedButton__legendIcon__3qHVr","iconFire":"MostPlayedButton__iconFire__3dCYG","iconStar":"MostPlayedButton__iconStar__10fFm","iconCrown":"MostPlayedButton__iconCrown__3uhva","iconChalice":"MostPlayedButton__iconChalice___LnsP","iconPlus":"MostPlayedButton__iconPlus__3lesO","iconArrow":"MostPlayedButton__iconArrow__NPDPo","text":"MostPlayedButton__text__2VpQr","active":"MostPlayedButton__active__3HZT-"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/MostPlayedButton/MostPlayedButton.css
// module id = 469
// module chunks = 0